module.exports = function() {
  return new Worker(__webpack_public_path__ + "a92ab87da8f2a6a1e0f0.worker.js");
};